import { parseColor as parse, Color } from '@progress/kendo-drawing';
import { isPresent, fitIntoBounds } from './misc';
/**
 * @hidden
 *
 * Returns the hex or RGBA string representation of the color.
 */

export var parseColor = function parseColor(value, format, safe) {
  if (safe === void 0) {
    safe = true;
  }

  var allowedFormats = ['hex', 'rgba']; // TODO: constant?
  // Angular supports third type: name : const allowedFormats: Array<string> = ['hex', 'rgba', 'name'];

  if (allowedFormats.indexOf(format) === -1) {
    throw new Error("Unsupported color output format '" + format + "'. The available options are 'hex' or 'rgba'.");
  }

  if (!isPresent(value)) {
    return;
  }

  var parsedColor = parse(value.trim(), safe);

  if (!isPresent(parsedColor)) {
    return;
  }

  return format === 'hex' ? parsedColor.toCss() : parsedColor.toCssRgba();
};
/**
 * @hidden
 *
 * Returns an HSV object representation of the color string.
 */

export var getHSV = function getHSV(value, safe) {
  if (safe === void 0) {
    safe = true;
  }

  var parsed = parse(value, safe);

  if (!isPresent(parsed)) {
    return {};
  }

  return parsed.toHSV();
};
/**
 * @hidden
 *
 * Returns an RGBA object representation of the color string.
 */

export var getRGBA = function getRGBA(value, safe) {
  if (safe === void 0) {
    safe = true;
  }

  var parsed = parse(value, safe);

  if (!isPresent(parsed)) {
    return {};
  }

  return parsed.toBytes();
};
/**
 * @hidden
 *
 * Returns the RGBA string representation of the color.
 */

export var getColorFromHSV = function getColorFromHSV(hsva) {
  var hue = fitIntoBounds(hsva.h, 0, 359.9);
  var saturation = fitIntoBounds(hsva.s, 0, 1);
  var value = fitIntoBounds(hsva.v, 0, 1);
  var alpha = fitIntoBounds(hsva.a, 0, 1);
  return Color.fromHSV(hue, saturation, value, alpha).toCssRgba();
};
/**
 * @hidden
 *
 * Returns the RGBA string representation of the color based on the `hue` and
 * assuming the `value`, `saturation`, and `alpha` have a value of `1`.
 */

export var getColorFromHue = function getColorFromHue(hue) {
  return getColorFromHSV({
    h: hue,
    s: 1,
    v: 1,
    a: 1
  });
};
/**
 * @hidden
 *
 * Returns the RGBA string representation of the color.
 */

export var getColorFromRGBA = function getColorFromRGBA(rgba) {
  var red = fitIntoBounds(rgba.r, 0, 255);
  var green = fitIntoBounds(rgba.g, 0, 255);
  var blue = fitIntoBounds(rgba.b, 0, 255);
  var alpha = fitIntoBounds(rgba.a, 0, 1);
  return Color.fromBytes(red, green, blue, alpha).toCssRgba();
};